var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlcoholLimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF0000",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9998 11.3334C20.9998 11.1566 20.9296 10.987 20.8046 10.862C20.6796 10.737 20.51 10.6667 20.3332 10.6667H18.6665C18.4897 10.6667 18.3201 10.737 18.1951 10.862C18.0701 10.987 17.9998 11.1566 17.9998 11.3334V19.4547C17.9998 19.5215 17.9857 19.5876 17.9584 19.6485C17.9312 19.7095 17.8915 19.7641 17.8418 19.8087C16.8424 20.7083 16.0433 21.8079 15.4963 23.0362C14.9493 24.2645 14.6665 25.5941 14.6665 26.9387V35.8614C14.6665 36.6747 15.3258 37.3334 16.1385 37.3334H22.4292C22.8457 37.3334 23.2452 37.1679 23.5398 36.8734C23.8344 36.5788 23.9998 36.1793 23.9998 35.7627V26.7087C23.9998 24.1207 22.9718 21.6387 21.1418 19.8087C21.0509 19.7179 20.9999 19.5946 20.9998 19.4661V11.3334ZM15.9998 27.3334H22.6665V32.6667H15.9998V27.3334ZM31.7592 24.0001H26.9065L27.3332 20.0001H31.3332L31.7592 24.0001ZM26.1332 18.6667H32.5332L33.2085 25.0241C33.3131 26.0078 33.0399 26.9946 32.4441 27.7844C31.8483 28.5741 30.9745 29.1079 29.9998 29.2774V36.0001H31.9998C32.1766 36.0001 32.3462 36.0703 32.4712 36.1953C32.5963 36.3204 32.6665 36.4899 32.6665 36.6667C32.6665 36.8436 32.5963 37.0131 32.4712 37.1382C32.3462 37.2632 32.1766 37.3334 31.9998 37.3334H26.6665C26.4897 37.3334 26.3201 37.2632 26.1951 37.1382C26.0701 37.0131 25.9998 36.8436 25.9998 36.6667C25.9998 36.4899 26.0701 36.3204 26.1951 36.1953C26.3201 36.0703 26.4897 36.0001 26.6665 36.0001H28.6665V29.2767C27.692 29.1072 26.8183 28.5736 26.2225 27.7839C25.6267 26.9943 25.3534 26.0077 25.4578 25.0241L26.1332 18.6667Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholLimit);
export default __webpack_public_path__ + "static/media/alcohol_limit.27785cef6d9271b872bd29227492e273.svg";
export { ForwardRef as ReactComponent };